module.exports = __webpack_public_path__ + "static/assets/a7865124496ca7daa46c9261b5c2aa9b.svg";